import useRemoveCourierPrivilege from "api/UserResource/useRemoveCourierPrivilege";
import { ConfirmPopup } from "primereact/confirmpopup";
import React from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { BsExclamationDiamond } from "react-icons/bs";
import { FiX } from "react-icons/fi";

const RemoveCourierPrevilege = (props) => {
	const { userId } = props;
	const [visible, setVisible] = React.useState(false);

	const elementId = `remove-courier-privilige-${userId}`;

	console.log({ elementId });

	const { mutateAsync, isLoading } = useRemoveCourierPrivilege();

	const revokePermission = async () => {
		try {
			await mutateAsync(userId);
			setVisible(false);
		} catch (error) {
			// console.log(error);
		}
	};

	return (
		<>
			<button
				type="button"
				className="appearance-none border-0 text-red-400 flex items-center gap-1"
				onClick={() => setVisible(true)}
				id={elementId}
			>
				Remove "Courier" privilege
				{isLoading ? (
					<AiOutlineLoading3Quarters
						size={15}
						className="animate-spin"
					/>
				) : (
					<FiX size={15} />
				)}
			</button>

			<ConfirmPopup
				target={document.getElementById(elementId)}
				visible={visible}
				onHide={() => setVisible(false)}
				className="font-sans text-sm"
				message={
					<div
						className="space-y-2"
						style={{ maxWidth: "400px" }}
					>
						<BsExclamationDiamond
							size={40}
							className="text-red-600"
						/>

						<p className="text-base font-bold">
							Do you want to remove "Courier" privilege from this user?
						</p>
						<p>
							Note that this action will result in the user losing their
							"Courier" privilege. The user will not be able to perform any
							courier related activities
						</p>
					</div>
				}
				accept={revokePermission}
			/>
		</>
	);
};

export default RemoveCourierPrevilege;
